import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { get } from 'lodash';

import pluralize from 'rebook/apps/utils/text/pluralize';
import uaDetector from 'rebook/apps/utils/uaDetector';
import ContextPagination from 'rebook/apps/base/components/ContextPagination';
import BookCitation from 'rebook/apps/books/components/BookCitation';
import BookListItemEmpty from 'rebook/apps/books/components/BookListItemEmpty';
import BookHasNotReviews from 'rebook/apps/books/components/BookHasNotReviews';
import BookCardHeader from 'rebook/apps/base/components/BookCardHeader';
import BreadCrumbs from 'rebook/apps/base/components/BreadCrumbs';
import * as BookCitationListActions from 'rebook/apps/books/actions/BookCitationListActions';
import { Book } from 'rebook/apps/books/models';

import styles from './style.scss';


class BookCitationListView extends React.Component {
  componentDidMount() {
    const { match, location } = this.props;
    // componentDidMount is never called server side
    // so we fetch data for client here
    this.props.BookCitationListActions.fetchInitialData(match, location);
  }

  componentWillUnmount() {
    this.props.BookCitationListActions.resetData();
  }

  static fetchInitialDataForServer(match, store) {
    return store.dispatch(BookCitationListActions.fetchInitialData(match));
  }

  changePage(newPageNumber) {
    window.scrollTo(0, 0);
    this.props.BookCitationListActions.fetchCitationList(newPageNumber);
  }

  render() {
    const { user } = this.props;
    const { citations, book, pageNumber, lastPageNumber } = this.props.bookCitationList;
    const theBook = new Book(book);
    const citationsCount = get(theBook, 'citations_count', 0);
    const UA = navigator && navigator.userAgent ? navigator.userAgent : null;

    if (!UA) {
      return null;
    }

    const isMobile = uaDetector.isMobile(UA);
    const mobileSeoText = `${pluralize(citationsCount, 'цитата', 'цитаты', 'цитат')}`;
    const desktopSeoText = `, ${pluralize(citationsCount, 'высказывание', 'высказывания', 'высказываний')},
      ${pluralize(citationsCount, 'выражение', 'выражения', 'выражений')},
      ${pluralize(citationsCount, 'афоризм', 'афоризма', 'афоризмов')} и
      ${pluralize(citationsCount, 'крылатая', 'крылатые', 'крылатых')}
      ${pluralize(citationsCount, 'фраза', 'фразы', 'фраз')}
      из книги`;
    const seoText = isMobile ? mobileSeoText : mobileSeoText + desktopSeoText;
    return (
      <div className={classNames('backgroundContainer', 'themeGrey')}>
        <div className="section">
          <BreadCrumbs links={[
            { text: 'Библиотека', url: '/catalog/' },
            { text: get(theBook, 'main_author.cover_name', ''), url: get(theBook, 'main_author.absolute_url', '') },
            { text: get(theBook, 'name', ''), url: get(theBook, 'absolute_url', '') },
            { text: 'Цитаты из книги', url: '' },
          ]} />
          {book && (
            <React.Fragment>
              <h1>Цитаты из книги <Link to={theBook.getLink()} className="link">&laquo;{theBook.name}&raquo;</Link></h1>
              <div className={styles.count}>
                {citationsCount}&nbsp;{seoText}
              </div>
              <div className={styles.bookCardHeaderContainer}>
                {citationsCount > 0
                  ? (
                    <BookCardHeader
                      user={user}
                      book={theBook}
                      withAuthor
                      withButton
                      GACategory="BookQuote" />
                  )
                  : (
                    <BookHasNotReviews>
                      Еще никто не делал цитат в книге &laquo;{theBook.name}&raquo;
                    </BookHasNotReviews>
                  )
                }
              </div>
            </React.Fragment>
          )}
          {citations === null
            ? [...Array(5)].map((citation, key) => (
              <BookListItemEmpty key={key} />
            ))
            : citations.map((citation, key) => (
              <BookCitation key={`${key}_${citation.id}`}
                extraClassName={styles.citationContainer}
                citation={citation}
                textTitle="Моя цитата" />
            ))
          }
          {lastPageNumber > 1 && (
            <ContextPagination
              onPageChange={(newPageNumber) => this.changePage(newPageNumber)}
              currentPage={pageNumber}
              lastPage={lastPageNumber} />
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    bookCitationList: state.bookCitationList,
    user: state.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    BookCitationListActions: bindActionCreators(BookCitationListActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BookCitationListView);
